import type { CurrentOrder } from '../domain/types';

// Assigned-driver card shown during DRIVER_ON_THE_WAY / DRIVER_IS_WAITING /
// TRIP_IN_PROGRESS. Driver + car info comes from the GET /order/rider/{id}
// poll (OrderDetailsModel fields), so no extra fetch is needed. Mirrors
// flutter_client driver_is_waiting.dart.
export function DriverCard({ order }: { order: CurrentOrder }) {
  const name = order.driverName?.trim() || 'Водій';
  const rating = order.driverRating != null ? order.driverRating.toFixed(1) : null;
  const carLabel = [order.carColorName, order.carName].filter(Boolean).join(' ').trim();
  const plate = order.carNumber?.trim() || null;
  const phone = order.driverPhone?.trim() || null;
  const photo = order.driverPhoto?.trim() || null;
  const carPhoto = order.carPhoto?.trim() || null;

  return (
    <div className="driver-card">
      <div className="driver-card__main">
        <div
          className="driver-card__avatar"
          style={photo ? { backgroundImage: `url(${photo})` } : undefined}
          aria-hidden="true"
        >
          {!photo && <span>{name.charAt(0).toUpperCase()}</span>}
        </div>
        <div className="driver-card__info">
          <div className="driver-card__name-row">
            <strong>{name}</strong>
            {rating && <span className="driver-card__rating">★ {rating}</span>}
          </div>
          {carLabel && <span className="driver-card__car">{carLabel}</span>}
          {plate && <span className="driver-card__plate">{plate}</span>}
        </div>
        {carPhoto && (
          <div className="driver-card__car-photo" style={{ backgroundImage: `url(${carPhoto})` }} aria-hidden="true" />
        )}
      </div>
      {phone && (
        <a className="driver-card__call" href={`tel:${phone}`}>
          Зателефонувати
        </a>
      )}
    </div>
  );
}
